<script lang="ts" setup>
  import { ref } from 'vue';
  import type { WarehouseResource } from '@storefront/resources';

  defineOptions({
    inheritAttrs: false,
  });

  interface Props {
    warehouses: WarehouseResource[],
  }

  defineProps<Props>();

  const show = ref(false);
</script>
<template>
  <SfButton :title="$t('SHOP.COMMON.ARIA.CHOOSE_WAREHOUSE')" aria-controls="warehouses-drawer" aria-haspopup="dialog" square transparent v-bind="$attrs" @click="show = true" @keydown.enter.prevent="show = true">
    <SfIconGeo aria-hidden="true" />
  </SfButton>
  <SfDrawerWarehouse v-model:open="show" :warehouses />
</template>
